import { render, staticRenderFns } from "./ScopedNotification.vue?vue&type=template&id=73f48dcf&scoped=true"
import script from "./ScopedNotification.vue?vue&type=script&lang=js"
export * from "./ScopedNotification.vue?vue&type=script&lang=js"
import style0 from "./ScopedNotification.vue?vue&type=style&index=0&id=73f48dcf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f48dcf",
  null
  
)

export default component.exports